<template>
  <div class="zoom-controls">
    <div class="zoom-label">Zoom Control</div>
    <div class="zoom-buttons-wrapper">
      <button class="zoom-btn zoom-btn-minus" @click="zoomOut" title="Zoom Out">
        <i class="ti-minus"></i>
      </button>
      <span class="zoom-percentage">{{ +(zoomLevel * 100).toFixed(0) }}%</span>
      <button class="zoom-btn zoom-btn-plus" @click="zoomIn" title="Zoom In">
        <i class="ti-plus"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'site-zoom-control',
  data() {
    return {
      zoomLevel: 1, // Default zoom level
    }
  },
  methods: {
    zoomIn(event) {
      event.preventDefault();
      this.zoomLevel += 0.1;
      if (this.zoomLevel > 2) {
        this.zoomLevel = 2; // Set a maximum zoom limit
      }

      this.applyZoom();
      localStorage.setItem('zoomLevel', this.zoomLevel);
    },
    zoomOut(event) {
      event.preventDefault();
      this.zoomLevel -= 0.1;
      if (this.zoomLevel < 0.5) this.zoomLevel = 0.5; // Set a minimum zoom limit
      this.applyZoom();
      localStorage.setItem('zoomLevel', this.zoomLevel);
    },
    applyZoom() {
      document.body.style.zoom = this.zoomLevel;
    },
    loadZoomLevel() {
      const savedZoomLevel = localStorage.getItem('zoomLevel');
      if (savedZoomLevel) {
        this.zoomLevel = parseFloat(savedZoomLevel);
        this.applyZoom();
      }
    },
    setInitialZoomBasedOnResolution(resetZoom = false) {
      if (!localStorage.getItem('zoomLevel')) {
        const screenWidth = window.screen.width;

        if (screenWidth < 1280) {
          this.zoomLevel = 0.9; // Slightly smaller for low-resolution screens
        } else if (screenWidth >= 1920) {
          this.zoomLevel = 1.1; // Slightly larger for high-resolution screens
        } else {
          this.zoomLevel = 1; // Default for mid-range resolutions
        }
        this.applyZoom();
        localStorage.setItem('zoomLevel', this.zoomLevel);
      }
    }
  },
  mounted() {
    this.setInitialZoomBasedOnResolution();
  }
}
</script>
<style lang="scss" scoped>
.zoom-controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.zoom-label {
  font-size: 13px;
  font-weight: 500;
  color: #66615B;
  text-align: center;
}

.zoom-buttons-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.zoom-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #1e88e5;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(30, 136, 229, 0.3);
}

.zoom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 136, 229, 0.4);
}

.zoom-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(30, 136, 229, 0.3);
}

.zoom-btn i {
  font-size: 14px;
}

.zoom-percentage {
  min-width: 50px;
  text-align: center;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.site-zoom-control {
    margin: 0 30px;
}

.zoom-content-control {
  padding: 5px;
}
</style>
